import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';


/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES
 * --------------------------------------------------------------------------- */

import FLEXGuide from "../../../../data/downloads/Manual_trygg_vardag_flex.pdf";
import FLEXProduktblad from "../../../../data/downloads/PRODUKTBLAD_Trygg_vardag_FLEX.pdf";

/* ============================================================================ */
/*          TYDLIG KALENDER PROd - function
/* ============================================================================ */

const TryggVardagFlex = () => {  
  const { t } = useTranslation("products/tryggvardagflex"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_FLEX')}</h1>

        <ProductDescription>
          <p>{t('p1_FLEX')}</p>
          <p>{t('p2_FLEX')}</p>
        </ProductDescription>

        <ProductInfo titel={t('dokument_FLEX')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_FLEX')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={FLEXGuide} download="FLEX_Snabbguide.pdf">
                    <span>Tryggvardag Flex Guide</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={FLEXProduktblad} download="FLEX_Produktblad.pdf">
                    <span>Tryggvardag Flex Produktblad</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
      </ProductSection>
    </main>
  );
};

export default TryggVardagFlex;
